import { t } from '@lingui/macro';
import {
  ConfigsStepPostSignQa,
  ConfigsStepPostSignQaAnswers,
  ConfigsStepPostSignQaAnswersTranslations,
  ConfigsStepPostSignQaTranslations,
  UserLookingForContract,
} from '@prismo-io/schemas';
import { z } from 'zod';

export const ANSWER_IDS_WITH_COMPLEMENT = [
  '47d3ed99-9345-450b-854f-1b264cb3e542',
  '97df3f46-d793-47c8-835d-276866f922f8',
];
export const ANSWER_IDS_WITH_JOB_COMPLEMENT = [
  '12fb1505-2556-463d-a441-f87cf5b353e2',
];

export const BorgheseSchema = z
  .object({
    questionId: z.string().uuid(),
    selected: z
      .array(z.string().trim().uuid())
      .min(1, t`Vous devez sélectionner au moins une option.`),
    complement: z
      .string()
      .trim()
      .min(1, t`Veuillez remplir ce champ.`)
      .optional(),
    lookingForContract: UserLookingForContract.optional(),
  })
  .refine(
    ({ selected = [], complement }) => {
      const needComplement = selected.some((id) =>
        ANSWER_IDS_WITH_COMPLEMENT.includes(id)
      );

      if (!needComplement) {
        return true;
      }

      return needComplement && complement?.trim();
    },
    {
      message: t`Ce champ est obligatoire.`,
      path: ['complement'],
    }
  )
  .refine(
    ({ selected = [], lookingForContract }) => {
      const needJobType = selected.some((id) =>
        ANSWER_IDS_WITH_JOB_COMPLEMENT.includes(id)
      );

      if (!needJobType) {
        return true;
      }

      return (
        needJobType && lookingForContract && lookingForContract?.length > 0
      );
    },
    {
      message: t`Vous devez sélectionner une option.`,
      path: ['lookingForContract'],
    }
  );

export type BorgheseSchemaT = z.infer<typeof BorgheseSchema>;

export const StepQuestionSchema = ConfigsStepPostSignQa.pick({
  id: true,
  metadata: true,
}).merge(
  z.object({
    translate: ConfigsStepPostSignQaTranslations.pick({
      sentence: true,
    }),
    answers: z.array(
      ConfigsStepPostSignQaAnswers.pick({
        id: true,
      }).merge(
        z.object({
          translate: ConfigsStepPostSignQaAnswersTranslations.pick({
            sentence: true,
          }),
        })
      )
    ),
  })
);

export type StepQuestionSchemaT = z.infer<typeof StepQuestionSchema>;
